import React, { useEffect } from 'react';
import BadgesContent from '@components/student/badges/Content';
import { Helmet } from 'react-helmet-async';
import {
  setNavbarWithTitleNoTopNavbar,
  resetToDefaultNavbarState,
  haveBottomNavbar,
} from '@atom/navbarAtom';
import { useStore } from 'jotai';

const BadgePage = () => {
  const store = useStore();
  // this is an example of defining navigation state.
  // It's as simple as defining what should exist at navbar, eliminating complex if else in navigation component
  useEffect(() => {
    store.set(haveBottomNavbar, false);
    // I use function inside to templating the usual navbar with template
    // We actually can just manipulate store directly, for example see GenieAsk page in Fullchatpage.tsx
    setNavbarWithTitleNoTopNavbar('Badges');

    // Don't forget to reset to default before leave the page.
    // With resetting to default we eliminate the need of defining state in each page and leave it to default behavior
    return () => {
      resetToDefaultNavbarState();
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>Geniebook - Badges</title>
        <meta name="description" content="Student Badges" />
      </Helmet>
      <BadgesContent />
    </>
  );
};

export default BadgePage;
